import { useEffect, useRef, useState } from 'react';
import { Toast } from 'react-bootstrap';

import CommonDescription from '../description/CommonDescription';
import { AppContext } from 'src/context/app';
import { useTimeAgo } from 'src/i18n';
import { ApiErrorInfo } from 'src/model/component';
import { useContextSetter } from 'src/utils/context';

interface Props {
  info: ApiErrorInfo;
}

export default function ApiErrorItem({ info }: Props) {
  const setState = useContextSetter(AppContext);
  const timeAgo = useTimeAgo();
  const intervalRef = useRef<NodeJS.Timeout>();
  const [timeStr, setTimeStr] = useState<string>('');
  const { millis, code, message } = info;

  useEffect(() => {
    intervalRef.current = setInterval(() => {
      setTimeStr(timeAgo.format(new Date(millis)).toString());
    }, 1000);

    return () => {
      clearInterval(intervalRef.current);
    };
  }, [millis, timeAgo]);

  const onClose = () => {
    setState((state) => {
      state.errors = state.errors.filter((v) => v.id !== info.id);
    });
  };

  return (
    <Toast bg="danger" onClose={onClose}>
      <Toast.Header>
        <strong className="me-auto">Error</strong>
        <small>{timeStr}</small>
      </Toast.Header>
      <Toast.Body>
        {code && <CommonDescription label="code" value={code} />}
        <CommonDescription label="message" value={message} />
      </Toast.Body>
    </Toast>
  );
}
